import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { CloseButton, Container, Modal, Spinner, Placeholder, PlaceholderButton, Card } from 'react-bootstrap';
import { FaPlay } from 'react-icons/fa';
import { withRouter } from './withRouter';
import { Helmet } from 'react-helmet';
import Help from "../components/Help";
import Analytics from "analytics";
import ReactPlayer from 'react-player';

import GameList from "constants/GameList";
import GamePackList from "constants/GamePackList";
import GameAddonList from "constants/GameAddonList";
import styles from './ShopSingleStyles.module.scss'
import Game from './Games/Game';
import { addToCart } from 'actions/cart';
import Reviews from "constants/reviews";
import DotLoader from 'components/Utlility/DotLoader';

// Slick Carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carouselStyles.css";
import Slider from "react-slick";
import StarFull from "images/template/full-star.png";
import StarEmpty from "images/template/empty-star.png";
import GiftBox from "images/Promotions/02642 Christmas Present.png";
// Lottie animations
import Lottie from 'react-lottie'
import time from 'animations/time-black.png'
import players from 'animations/minPlayers-black.png'

import age6Black from "animations/ageRatings/age-6.png";
import age8Black from "animations/ageRatings/age-8.png";
import age10Black from "animations/ageRatings/age-10.png";
import age12Black from "animations/ageRatings/age-12.png";
import age14Black from "animations/ageRatings/age-14.png";

import placeHolderDesktop from 'images/gameStorePreviews/placeholder-desktop.png';
import placeHolderMobile from 'images/gameStorePreviews/placeholder-mobile.png';
import kickstarterLogo from 'images/kickstarter-logo.png';
import PricingFunctions from '../common/PricingFunctions';

import { APP_TYPES } from "constants/AppTypes";
import WebIcon from "images/icons/web-icon.png";
import FireTVIcon from "images/icons/FireTV-Icon.png";
import RokuIcon from "images/icons/Roku-Icon-v2.png";


const howItWorksBlocks = [
    {
        number: 1,
        title: "GET IT ON THE BIG SCREEN",
        //"description": "Only one person needs to own the games. They will be 'party leader' and it's their job to get Game.City up on the biggest screen they can. Use Teams, Zoom or Discord if you want to play online. Use a smart TV to open it with a browser or connect up with a laptop and HDMI. Once you have achieved that, simply log in to your account."
        "description": "Open Game.City on Fire TV, Roku, smart TV, or laptop and log in!"
    },
    {
        number: 2,
        title: "GATHER SOME FRIENDS",
        //description: "Gather some friends, either online or in the same room. Once you have Game.City on the screen and you're logged in, players simply need to scan the QR code to join in, or head to Game.City and join using the Room Code.",
        description: "Scan the QR code or enter the Room Code at Game.City.",
    },
    {
        number: 3,
        title: "PLAY AND HAVE FUN",
        //description: "Once joined, choose a potato avatar, change your nickname and then choose a game. Get playing and have a great time. All our online games are extra family friendly so everyone can enjoy!"
        description: "Choose an avatar, pick a game, and enjoy"
    }
];

class ShopSingle extends Component {
    static displayName = ShopSingle.name;

    constructor(props) {
        super(props);

        this.state = {
            showHowToPlay: false,
            showTrailer: false,
            isLoading: true,
            price: this.getPrice(),
            oldPrice: this.getPrice(true)
        };
    }

    carouselSettings = {
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />,
        customPaging: function (i) {
            return (
                <div className="carousel-dot">

                </div>
            );
        },
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.game) {
            Analytics.viewContent(this.props.game.productId);

            const images = [
                this.props.game.meta.storeBackground,
                this.props.game.meta.storeLogo,
                this.props.game.meta.previewImages.mobile1,
                this.props.game.meta.previewImages.desktop1,
                this.props.game.meta.previewImages.desktop2,
                this.props.game.meta.previewImages.mobile2,
            ];
            Promise.all(images.map(image => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.onload = resolve;
                    img.onerror = reject;
                    img.src = image;
                });
            })).then(() => {
                setTimeout(() => {
                    this.setState({ isLoading: false });
                }, 100);
            }).catch(error => {
                // if there's an error, we still want to show the app, so set isLoading to false
                this.setState({ isLoading: false });
            });
        } else {
            this.props.navigate("/shop");
        }
    }

    getStoreBackground() {
        return {
            backgroundColor: this.props.game?.meta.storeBackgroundColour,
            backgroundImage: `url(${this.props.game?.meta.storeBackground})`,
        }
    }

    getStoreAccentBorder() {
        return {
            backgroundColor: this.props.game?.meta.storeAccentColour,
            border: `10px solid ${this.props.game?.meta.storeAccentColour}`
        }
    }

    getStoreAccentBackground() {
        return {
            backgroundColor: this.props.game?.meta.storeAccentColour,
            border: `10px solid ${this.props.game?.meta.storeAccentColour}`
        }
    }

    getStoreAccentImageBorder() {
        return {
            border: `2px solid ${this.props.game?.meta.storeAccentColour}`
        }
    }

    getStoreInfoBackground() {
        return {
            //backgroundColor: `${this.props.game?.meta.storeInfoBackground}`
        }
    }

    addGameToCart(game) {
        this.props.addToCart(game);
    }

    openInNewTab(url) {
        window.open(url, '_blank').focus();
    }


    getPrice(old) {
        let countryCode = this.props.pricing.countryCode;
        return PricingFunctions.getGamePricing(countryCode, this.props.game, old)?.display;
    }

    closeHelpModal = () => {
        this.setState({ showHowToPlay: false, });
    }

    closeTrailerModal = () => {
        this.setState({ showTrailer: false });
    }

    openTrailerModal = () => {
        this.setState({ showTrailer: true });
    }

    goToAddon(g) {
        this.props.navigate(g.storeSlug)
    }

    getAdditionalStyles() {
        if (this.props.game?.gameId === "playing_with_fire") {
            console.log("fugupulung")
            return {
                imageRendering: 'pixelated',
                marginBottom: '5vh',
            }
        }
    }

    getAgeIcon() {
        switch (this.props.game?.gameInfo.minAge) {
            case 6:
                return age6Black;
            case 8:
                return age8Black;
            case 10:
                return age10Black;
            case 12:
                return age12Black;
            case 14:
                return age14Black;
            default:
                return age8Black;
        }
    }

    getSupportedPlatforms() {
        if (!this.props.game) return;

        let platforms = [];
        for (let i = 0; i < this.props.game.supportedPlatforms.length; i++) {
            let platform = this.props.game.supportedPlatforms[i];
            let img = null;
            let link = null;

            switch (platform) {
                case APP_TYPES.WEB:
                    img = WebIcon;
                    break;
                case APP_TYPES.FIRE_TV:
                    img = FireTVIcon;
                    link = "https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6";
                    break;
                case APP_TYPES.ROKU:
                    img = RokuIcon;
                    link = "https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv";
                    break;
                default:
                    break;
            }

            if (img != null) {
                if (link != null) {
                    platforms.push(
                        <div className={styles.platform}>
                            <a href={link} target="_blank">
                                <img src={img} />
                            </a>
                        </div>
                    )
                } else {
                    platforms.push(
                        <div className={styles.platform}>
                            <img src={img} />
                        </div>
                    )
                }
            }
        }

        return platforms;
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>Game City - {this.props.game?.name}</title>
                    <link rel="canonical" href={`https://game.city/${this.props.game?.storeSlug}`} />
                    <meta name="description" content={this.props.game?.description} />
                </Helmet>
                <div className={styles.pageShopSingle} style={this.getStoreBackground()}>
                    <section className={`${styles.band}`}>
                        <Container className="text-center">
                            <div className='row'>
                                <div className='offset-xl-1 col-xl-10'>
                                    {/*<div className={styles.backButton}>*/}
                                    {/*    <button onClick={() => this.props.navigate("/shop")} className={`${styles.button} ${styles.alternate} ${styles.small}`} style={{ width: "fit-content" }}><BiLeftArrowAlt /> Back</button>*/}
                                    {/*</div>*/}
                                    <div className={styles.gameLogo}>
                                        <img src={this.props.game?.meta.storeLogo} style={this.getAdditionalStyles()} className={`  ${styles.storeLogo} ${this.props.game?.meta.storeLogo2 && styles.hasSecond}`} alt={`${this.props.game.name} Logo`} />
                                        {this.props.game?.meta.storeLogo2 && <img src={this.props.game?.meta.storeLogo2} className={styles.storeLogo2} alt={`${this.props.game.name} logo`}></img>}
                                    </div>
                                    {/* {console.log(this.state.game.gameInfo?.minAge)} */}
                                    <div className='row'>
                                        <div className='col-lg-8 order-2 order-lg-1 text-center'>
                                            <div className={`${styles.previewImages} d-none d-lg-block`} style={{
                                                ...(this.props.game.gameId === 'playing_with_fire'
                                                    ? { boxShadow: 'none' }
                                                    : {}),
                                                ...this.getStoreAccentBorder(),
                                                ...this.getStoreAccentBackground(),
                                            }}>

                                                {
                                                    // check if game id
                                                    this.props.game.meta.singleImage ? (
                                                        <>
                                                            <img className={styles.desktopPreview} src={this.state.isLoading ? placeHolderDesktop : this.props.game.meta?.previewImages?.singleImage} style={{ width: "100%", boxShadow: 'none' }}></img>
                                                        </>
                                                    )
                                                        : (
                                                            <>
                                                                <div className={styles.imageRow}>
                                                                    <div style={this.getStoreAccentImageBorder()}>
                                                                        <img className={styles.mobilePreview} src={this.state.isLoading ? placeHolderMobile : this.props.game.meta?.previewImages?.mobile1}></img>
                                                                    </div>
                                                                    <div style={this.getStoreAccentImageBorder()}>
                                                                        <img className={styles.desktopPreview} src={this.state.isLoading ? placeHolderDesktop : this.props.game.meta?.previewImages?.desktop1}></img>
                                                                    </div>
                                                                </div>
                                                                <div className={styles.imageRow}>
                                                                    <div style={this.getStoreAccentImageBorder()}>
                                                                        <img className={styles.desktopPreview} src={this.state.isLoading ? placeHolderDesktop : this.props.game.meta?.previewImages?.desktop2}></img>
                                                                    </div>
                                                                    <div style={this.getStoreAccentImageBorder()}>
                                                                        <img className={styles.mobilePreview} src={this.state.isLoading ? placeHolderMobile : this.props.game.meta?.previewImages?.mobile2}></img>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                }

                                            </div>

                                            <div className={`${styles.previewImages} ${styles.mobile} d-block d-lg-none`} style={this.getStoreAccentBorder()}>
                                                {
                                                    // check if game id
                                                    this.props.game.meta.singleImage ?
                                                        <img className={styles.desktopPreview} src={this.state.isLoading ? placeHolderDesktop : this.props.game.meta?.previewImages?.desktop1} style={{ width: "100%", boxShadow: 'none' }}></img>
                                                        :
                                                        <>
                                                            <div className={`${styles.imageRow} ${styles.singleDesktopRow}`}>
                                                                <div style={this.getStoreAccentImageBorder()}>
                                                                    <img src={this.state.isLoading ? placeHolderDesktop : this.props.game.meta?.previewImages?.desktop1}></img>
                                                                </div>
                                                            </div>
                                                            <div className={`${styles.imageRow} ${styles.singleDesktopRow}`}>
                                                                <div style={this.getStoreAccentImageBorder()}>
                                                                    <img src={this.state.isLoading ? placeHolderDesktop : this.props.game.meta?.previewImages?.desktop2}></img>
                                                                </div>
                                                            </div>
                                                            <div className={`${styles.imageRow} ${styles.doubleColRow}`}>
                                                                <div style={this.getStoreAccentImageBorder()}>
                                                                    <img src={this.state.isLoading ? placeHolderMobile : this.props.game.meta?.previewImages?.mobile1}></img>
                                                                </div>
                                                                <div style={this.getStoreAccentImageBorder()}>
                                                                    <img src={this.state.isLoading ? placeHolderMobile : this.props.game.meta?.previewImages?.mobile2}></img>
                                                                </div>
                                                            </div>
                                                        </>

                                                }
                                            </div>

                                        </div>

                                        <div className='col-lg-4 order-1 order-lg-2'>
                                            <div className={styles.gameInfoWrapper} style={this.getStoreInfoBackground()}>
                                                {
                                                    this.props.game.gameInfo.cornerBanner &&
                                                    (!this.props.game.gameInfo.cornerBanner.shopOnly || !this.props.fromLobby) &&
                                                    <div className={styles.cornerBanner} style={{ background: this.props.game.gameInfo.cornerBanner.colour }}>
                                                        {this.props.game.gameInfo.cornerBanner.text}
                                                    </div>
                                                }
                                                {
                                                    <div className={styles.priceContainer}>
                                                        {this.state.oldPrice && (
                                                            <p className={styles.oldPrice}>{this.state.oldPrice}</p>
                                                        )}
                                                        <p className={styles.gamePrice}><strong>{this.state.price || <DotLoader size="medium" variant="dark" />}</strong></p>
                                                    </div>
                                                }
                                                {
                                                    this.props.game?.kickstarter ?
                                                        <button className={`${styles.button} ${styles.kickstarter}`} onClick={() => this.openInNewTab("https://www.kickstarter.com/projects/1169339123/1485717407?ref=2maee1")}>
                                                            FIND OUT MORE ON
                                                            <br />
                                                            <img src={kickstarterLogo} className={styles.kickstarterLogo}></img>
                                                        </button>
                                                        :
                                                        <button className={styles.button} onClick={() => this.addGameToCart(this.props.game)}>{this.state.loading ? <DotLoader size="medium" variant="dark" /> : "Add To Cart"}</button>
                                                }
                                                {/*<br />*/}
                                                {/*<button className={`${styles.button} ${styles.small} alternate}`} onClick={() => this.setState({ showHowToPlay: true, })}>{this.state.loading ? <Spinner animation="border" /> : "How To Play"}</button>*/}

                                                {
                                                    !this.props.game?.kickstarter &&
                                                    <ul className={styles.gameInfo}>
                                                        <li>
                                                            <div className={styles.icon}>
                                                                <img src={time} />
                                                            </div>
                                                            <span>{this.props.game.gameInfo?.avgRoundLengthText}</span>
                                                        </li>
                                                        <li>
                                                            <div className={styles.icon}>
                                                                <img src={players} />
                                                            </div>
                                                            <span>{this.props.game.gameInfo?.minPlayers}-{this.props.game.gameInfo?.maxPlayers ?? 8} Players</span>
                                                        </li>
                                                        <li>
                                                            <div className={styles.icon}>
                                                                <img src={this.getAgeIcon()} />
                                                            </div>
                                                            <span>
                                                                Age {this.props.game.gameInfo?.minAge}+
                                                            </span>
                                                        </li>
                                                    </ul>
                                                }


                                                <hr></hr>

                                                {
                                                    this.props.game?.meta?.trailerURL &&
                                                    <button className={`${styles.button} ${styles.trailerButton} ${styles.small}`} onClick={this.openTrailerModal}>
                                                        <FaPlay /> Watch Trailer
                                                    </button>
                                                }

                                                <ul className={styles.gameDescription}>
                                                    {this.props.game.gameInfo?.descriptions.map(description => {
                                                        return (<li>
                                                            <p className={styles.descriptionHeader}>{description.header}</p>
                                                            <p className={styles.descriptionBody}>{description.body}</p>
                                                        </li>)
                                                    })}
                                                </ul>
                                                {
                                                    this.props.game?.kickstarter &&
                                                    <>

                                                        <hr></hr>
                                                        <button className={`${styles.button} ${styles.kickstarter}`} onClick={() => this.openInNewTab("https://www.kickstarter.com/projects/1169339123/deal-or-no-deal-the-party-game-for-your-tv")}>
                                                            FIND OUT MORE ON
                                                            <br />
                                                            <img src={kickstarterLogo} className={styles.kickstarterLogo}></img>
                                                        </button>
                                                    </>
                                                }
                                                {
                                                    <>
                                                        <hr></hr>
                                                        <p className={styles.header}>Supported Platforms</p>
                                                        <div className={styles.platformsList}>
                                                            {this.getSupportedPlatforms()}
                                                        </div>
                                                    </>
                                                }
                                                {this.props.game.licence &&
                                                    <>
                                                        <hr></hr>
                                                        <div className={styles.gameLicence}>
                                                            {this.props.game.licence}
                                                        </div>
                                                    </>
                                                }
                                                {
                                                    (GamePackList.find((x) => x.gamePackInfo.gamesIncluded.find(i => i.gameId === this.props.game.gameId)) || this.props.game.addonIds.length > 0) &&
                                                    <hr></hr>
                                                }
                                                {
                                                    GamePackList.find((x) => x.gamePackInfo.gamesIncluded.find(i => i.gameId === this.props.game.gameId)) && <div className={styles.addons} >
                                                        <p className={styles.header}>Included In</p>
                                                        <div className={styles.addonsList}>
                                                            {
                                                                GamePackList.filter((x) => x.enabled && x.gamePackInfo.gamesIncluded.find(i => i.gameId === this.props.game.gameId)).map((g) => {
                                                                    return <div className={styles.addonItem} onClick={() => this.goToAddon(g)}>
                                                                        <img src={g.meta.tinyCard} alt={`${g.name}`} className={styles.tinyCard} />
                                                                        <div className={styles.details} >
                                                                            <div className={styles.detailsWrapper} >
                                                                                {g.subNames.map(n => {
                                                                                    return <p className={styles.addonHeader}> {n}</p>
                                                                                })}
                                                                                <p className={styles.addonPrice}>{PricingFunctions.getGamePricing(this.props.pricing.countryCode, g).display}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                {this.props.game.addonIds.length > 0 && <div className={styles.addons} >
                                                    <p className={styles.header}>Add-ons</p>
                                                    <div className={styles.addonsList}>
                                                        {
                                                            GameAddonList.filter((x) => this.props.game.addonIds.includes(x.addonId)).map((g) => {
                                                                return <div className={styles.addonItem} onClick={() => this.goToAddon(g)}>
                                                                    <img src={g.meta.tinyCard} alt={`${g.name}`} className={styles.tinyCard} />
                                                                    <div className={styles.details} >
                                                                        <div className={styles.detailsWrapper} >
                                                                            <p className={styles.addonHeader}> {g.name}</p>
                                                                            <p className={styles.addonPrice}>{PricingFunctions.getGamePricing(this.props.pricing.countryCode, g).display}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </section>
                    {/*<section className={`${styles.subContent}`}>*/}
                    <section className={`${styles.band} ${styles.sm}`} style={this.getStoreAccentBackground()}>

                        {/*<div className={styles.cityBG} style={{width: "100%", height: "100%", position: "absolute"}}></div>*/}
                        <Container style={{ zIndex: 2, position: "relative", padding: "10px" }}>
                            <div className="row text-center my-5" id="how-it-works">
                                <h2 className='text-uppercase mb-1'>Unsure about how it works?</h2>
                                <h4 className={`${styles.subTitle} text-uppercase`}>Playing a party game on your TV might sound like magic, but don't worry<br />it's as easy as 1-2-3.</h4>
                                <div className={`${styles.howItWorksBox} py-3`}>
                                    {
                                        howItWorksBlocks.map((x) => {
                                            return <div className={`${styles.howItWorksBlock} my-3`}>
                                                <div className={styles.number}>
                                                    <p>{x.number}</p>
                                                </div>
                                                <h3 className={styles.title}>{x.title}</h3>
                                                <p className={styles.description}>{x.description}</p>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                            <div className={`row text-center my-5 ${styles.moreGames}`}>
                                <h2 className='text-uppercase'>More Games You'll Like</h2>


                                {GameList.filter((x) => x.enabled && this.props.game.gameUpsellIds.includes(x.gameId)).map(g => <div className='col-md-6 col-lg-4 text-center'><Game showAddToCart={true} game={g} key={g.gameId} /></div>)}

                                {/* {GameList.filter(g => {g.gameId !== this.props.game.gameId }).map(g => <div className='col-md-6 col-lg-3 text-center'><Game game={g} key={g.gameId} /></div> )} */}

                                {/* {console.log(GameList.filter(g => {g.gameId !== this.props.game.gameId }))} */}
                            </div>
                        </Container>
                    </section>
                    <section className={`${styles.reviewsSection} ${styles.band} ${styles.large}`}>
                        <Slider className={styles.carousel} {...this.carouselSettings}>
                            {
                                Reviews.map((review) => {
                                    return <div className={`${styles.reviewWidth} container p-0`}>
                                        <div className={`${styles.reviewCard} card text-center mx-3 border-0 p-3`}>
                                            <h5 className={`${styles.reviewTitle} card-title`}>{review.name}</h5>
                                            <div className="row d-flex w-50 m-auto">
                                                {Array.from(Array(5), (e, i) => {
                                                    return <div className="col p-1">
                                                        <img className="img-fluid m-auto" style={{}} src={i <= review.stars - 1 ? StarFull : StarEmpty} />
                                                    </div>
                                                })}
                                            </div>
                                            <div className={`${styles.reviewBody} card-body`}>
                                                <p className={`${styles.reviewText} card-text`}>{review.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </Slider>
                    </section>
                </div>
                <Modal show={this.state.showHowToPlay} onHide={this.closeHelpModal} contentClassName={styles.rounded} >
                    <CloseButton style={{ position: "absolute" }} onClick={this.closeHelpModal} />
                    <Help />
                </Modal>
                <Modal show={this.state.showTrailer} onHide={this.closeTrailerModal} size="lg" centered contentClassName={styles.trailerModal}>
                    <Modal.Header closeButton className={styles.trailerModalHeader}>
                        <Modal.Title>{this.props.game?.name} - Trailer</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className={styles.trailerModalBody}>
                        <div className={styles.videoWrapper}>
                            <ReactPlayer
                                url={this.props.game?.meta?.trailerURL}
                                controls
                                playing={this.state.showTrailer}
                                width='100%'
                                height='100%'
                                className={styles.reactPlayer}
                            />
                        </div>
                    </Modal.Body>
                </Modal>
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopSingle));